import { RegistrationFilters } from '../constants';

export type ContentPropsT = {
	handleFilterSubmit: (submittedFilters: RegistrationFilters) => void;
	onClose: () => void;
};

export const FORM_FIELD_KEYS = {
	MANAGER_NAME: 'managerName',
	DEPARTMENT: 'department',
	DESIGNATION: 'designation',
	ROLE_NAME_TEMP: 'roleNameTemp',
	EMAIL: 'email'
};
